import React from 'react';

export function isClassComponent(
    component: React.ComponentType<any>
): component is React.ComponentClass<any> {
    return typeof component === 'function' && !!component.prototype?.isReactComponent;
}
